/**
 * Direct File & Image Downloader for S3 Presigned URLs
 * Uses ResponseContentDisposition='attachment' to download directly to local disk without CORS.
 */

export const downloadFileFromUrl = async (url, fileName = "photo.jpg") => {
  if (!url) {
    console.warn("No URL provided for download");
    return false;
  }

  try {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName || "download");
    // Ensure target is _self or not opening new window so browser handles attachment stream directly
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      if (document.body.contains(link)) {
        document.body.removeChild(link);
      }
    }, 1000);
    return true;
  } catch (err) {
    console.error("Download failed:", err);
    return false;
  }
};

export default downloadFileFromUrl;
